export const PARAM_KEYS = Object.freeze({
  SITE_SLUG: 'siteSlug',
  SKUS: 'skus',
  ZIP_CODE: 'zipCode',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  VARIATION_ID: 'variationId',
});

export const REQUIRED_PARAM_KEYS = Object.freeze([
  PARAM_KEYS.SITE_SLUG,
  PARAM_KEYS.SKUS,
  PARAM_KEYS.ZIP_CODE,
  PARAM_KEYS.START_DATE,
  PARAM_KEYS.END_DATE
]);